// type ArrayElement<T extends readonly unknown[]> = T extends readonly (infer U)[] ? U : never;

// https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
export const shuffleArray = <T>(array: Array<T>) => {
	const copy = array.slice();
	for (let i = copy.length - 1; i >= 1; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[copy[i], copy[j]] = [copy[j], copy[i]];
	}
	return copy;
};
